/* Traqdo mobile app links */
export const playStoreLink: string = 'https://play.google.com/store/apps/details?id=com.nuvay.traqdo_mob_app&pcampaignid=web_share';
export const appStoreLink: string = 'https://apps.apple.com/lk/app/traqdo/id6739690655';


/* Traqdo Social media links */
export interface SocialMedia {
    id?: number;
    name?: string;
    icon?: string;
    link?: string | null;
    status?: 1 | 0;
}

export const socialMedia: SocialMedia[] = [
    {
        id: 1,
        name: 'Linkedin',
        icon: 'ri-linkedin-fill',
        link: 'https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=true&heroEntityKey=urn%3Ali%3Aorganization%3A89230090&keywords=traqdo&origin=RICH_QUERY_SUGGESTION&position=0&searchId=4b6b710f-2d78-4cd7-aa87-67bbbd55ef39&sid=_%3B(&spellCorrectionEnabled=false',
        status: 1
    },
    {
        id: 2,
        name: 'Facebook',
        icon: 'ri-facebook-fill',
        link: null,
        status: 0
    },
    {
        id: 3,
        name: 'Instagram',
        icon: 'ri-instagram-line',
        link: null,
        status: 0
    },
    {
        id: 4,
        name: 'Twitter',
        icon: 'ri-twitter-x-line',
        link: null,
        status: 0
    },
    {
        id: 5,
        name: 'Threads',
        icon: 'ri-threads-line',
        link: null,
        status: 0
    },
    {
        id: 6,
        name: 'Youtube',
        icon: 'ri-youtube-fill',
        link: null,
        status: 0
    }
]